import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import UserQuote from './components/UserQuote';

const BackgroundContainer = styled(Box)`
  ${({ theme: { palette } }) => `
    background: url('./assets/pattern-x3.png'), linear-gradient(45deg, ${palette.secondary.main}, ${palette.secondary.main} 50%, ${palette.primary.main});
    background-attachment: fixed;
    box-shadow: inset 1px 1px 10px rgba(0,0,0,0.2);
  `}
`;

const SectionAboveTheFold: FunctionComponent = () => {
  return (
    <BackgroundContainer>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Hidden only="xs">
            <Grid item xs={12} md={8}></Grid>
          </Hidden>
          <Grid item xs={12} md={4}>
            <UserQuote author="Cosmo Knudsen" authorKey="cosmo" />
          </Grid>
        </Grid>
      </Container>
    </BackgroundContainer>
  );
};

export default SectionAboveTheFold;
